export default __webpack_public_path__ + "static/media/compiegne5.5ce18b08.jpg";